import _ from "lodash";

import { PerformanceQuestionWithAnswers } from "lib/frontend/cm/utils/hooks";
import { FieldType, PerformanceAnswer } from "prisma/cm/client";

import { FieldDefinition, UsageModel } from "../../fieldDefinition";
import { FieldSourceType } from "../../types";

export function fromPerformanceQuestion(
  performanceQuestion: PerformanceQuestionWithAnswers,
): FieldDefinition {
  const fieldDef: FieldDefinition = new FieldDefinition({
    id: performanceQuestion.id,
    baseModel: UsageModel.User,
    fieldSourceType: FieldSourceType.PERFORMANCE_QUESTION,
    valueGetter: (user) => {
      if (!user) {
        return null;
      }

      const performanceAnswer = _.find(performanceQuestion.answers ?? [], {
        userId: user.id,
      }) as PerformanceAnswer | undefined;

      return performanceAnswer?.value ?? null;
    },
    fieldTypes: [FieldType.TEXT],
  });

  fieldDef.label = performanceQuestion.title;

  fieldDef.textPopulated = true;

  return fieldDef;
}
